export const convertObjectToFormData = (obj: any) => {

    const formData = new FormData();
    for (let [key, value] of Object.entries(obj)) {
        //if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            if (value instanceof File) {
                formData.append(key, value);
            } else if (Array.isArray(value)) {
                value.forEach((item: any) => {
                    formData.append(`${key}[]`, item);
                });
            } else if (value instanceof Date) {
                formData.append(key, value.toUTCString());
            } else if (value === null || value === undefined) {
                formData.append(key, '');
            } else {
                formData.append(key, value);
            }
        //}
    }
    return formData;
}